<div class="classificacao-filter">
    <div class="classificacao-filter-quick">
        <div class="classificacao-filter-quick-block classificacao-filter-quick-block-options">

            <!-- Tipos de Classificações -->
            <div class="classificacao-filter-quick-block-options-multiselect-item">
                <sgt-tipo-classificacao-multiselect
                    [(idsTiposClassificacoes)]="filter.idsTiposClassificacoes"
                    (idsTiposClassificacoesChange)="onChangeTiposClassificacoes()"
                    defaultTitle="Tipos"
                    [disabled]="!isFilterInitialized">
                </sgt-tipo-classificacao-multiselect>
            </div>

            <!-- KPIs - Cross Sell -->
            <div class="classificacao-filter-quick-block-options-multiselect-item">
                <sgt-cross-sell-multiselect
                    [(crossSells)]="filter.crossSells"
                    (crossSellsChange)="onChangeCrossSells()"
                    defaultTitle="Cross Sell"
                    [disabled]="!isFilterInitialized">
                </sgt-cross-sell-multiselect>
            </div>           

            <!-- Situação -->
            <div class="classificacao-filter-quick-block-options-situacao">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            Situação
                        </span>
                    </div>
                    <select class="form-control" name="filterSituacao" id="filterSituacao"
                        [ngModel]="filter.situacao || ''" (ngModelChange)="onChangeSituacao($event ? $event : null)"
                        #filterSituacao="ngModel">
                        <option value="">Todas Situações</option>
                        <option *ngFor="let situacao of situacoes" [ngValue]="situacao.id">{{situacao.nome}}</option>
                    </select>
                </div>
            </div>

            <div class="classificacao-filter-quick-block-options-filter-psq">
                <input type="text" class="form-control" [(ngModel)]="filter.filterPsq"  #filterPsq="ngModel" name="filterPsq" id="filterPsq" placeholder="Digite para pesquisar...">
            </div>

            <div class="classificacao-filter-quick-block-options-btns">
                <div class="classificacao-filter-quick-block-options-btns">
                    <div class="btn-group">
                        <button type="button" class="btn btn-light" (click)="refresh()" title="Atualizar"
                            [disabled]="!isFilterInitialized">
                            <i class="fas fa-sync"></i>
                        </button>
                        <button type="button" class="btn btn-light" (click)="clear()" title="Limpar filtro e atualizar"
                            [disabled]="!isFilterInitialized">
                            <i class="fas fa-eraser" aria-hidden="true"></i>
                        </button>
        
                        <!--
                        <button type="button" class="btn" [class.btn-light]="!filter.isFilterDirty" [class.btn-danger]="filter.isFilterDirty"
                            (click)="toggleCollapse()" title="Filtro avançado"
                            [disabled]="!isFilterInitialized">
                            <ng-template [ngIf]="isFilterInitialized">
                                <i class="fas fa-filter" aria-hidden="true"></i>
                                <i [class]="collapseIcon" aria-hidden="true"></i>
                            </ng-template>
                            <ng-template [ngIf]="isFilterInitializing">
                                <i class='fas fa-spinner fa-pulse'></i>
                            </ng-template>
                        </button>
                        -->
                    </div>                      
                </div>
            </div>
        </div>
    </div>

    <div class="classificacao-filter-collapse" #filterCollapse></div>
</div>
